module.exports = __webpack_public_path__ + "static/media/detective_Intro_spritesheet.17584f98.png";